let hasLocalStorage = false;
try {
  hasLocalStorage = !!(window && window.localStorage);
} catch (err) {
  /* Noop */
}
export const get = (key = '') => {
  let value = '';
  if (hasLocalStorage) {
    try {
      value = window.localStorage[key] || '';
    } catch (err) {
      // Noop
    }
  }
  return value;
};
export const set = (key = '', value = '') => {
  if (hasLocalStorage) {
    try {
      window.localStorage[key] = value || '';
    } catch (err) {
      // Noop
    }
  }
  return value;
};
export const remove = (key = '') => {
  if (hasLocalStorage && key) {
    try {
      window.localStorage.removeItem(key);
    } catch (err) {
      /* Noop */
    }
  }
};